
<template>
  <v-container class="p-0">
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />

    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!--popup when user clicks on view-->
    <v-dialog v-model="promoPreview" max-width="450px" overlay-opacity="0">
      <v-card class="promo">
        <div
          class="discount"
          :style="{
            backgroundImage: 'url(' + promoPreviewDetails.imgUrl + ')',
          }"
        ></div>
        <div class="promo-text">
          <div>{{ promoPreviewDetails.name }}</div>
          <div>{{ promoPreviewDetails.code }}</div>
        </div>
        <div class="cta">
          <div v-if="promoPreviewDetails.promoType == 'Retail'">
            <img src="@/assets/luxestyle-promotion.png" width="50%" />
          </div>
          <div v-else>
            <img src="@/assets/pawn-promotion.png" width="80%" />
          </div>
          <button>{{ promoPreviewDetails.btnTitle }}</button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog View -->
    <div
      v-if="redeemId !== null"
      class="dialog-ann-wrapper dialog-screen-wrapper"
    >
      <div class="redeem-content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeDialog">Close</span>
        </div>
        <div class="title-section">{{ promoPreviewDetails.name }}</div>
        <div class="title-section">{{ promoPreviewDetails.code }}</div>
        <div class="title-section">
          {{
            "Start Date: " +
            new Date(
              promoPreviewDetails.dateTimeStart._seconds * 1000
            ).toLocaleDateString()
          }}
        </div>
        <div class="title-section">
          {{
            "End Date: " +
            new Date(
              promoPreviewDetails.dateTimeEnd._seconds * 1000
            ).toLocaleDateString()
          }}
        </div>

        <hr style="margin: 10px" />
        <h4>Scan User QR below:</h4>
        <input class="" id="userId" type="text" v-model="userId" />
        <hr style="margin: 10px" />
        <v-btn color="#00457C" @click="redeemPromotion" class="redeem-btn"
          >Redeem</v-btn
        >
      </div>
    </div>

    <v-row>
      <v-col cols="12" md="8" class="pt-0">
        <div
          v-if="this.$store.state.user.roles.my_app_admin"
          class="header text-left"
        >
          Manage Promotions
        </div>
        <div v-else class="header text-left">Manage Promotion Redemptions</div>
      </v-col>
      <v-col cols="12" md="4" class="action-buttons pt-0">
        <v-btn
          v-if="this.$store.state.user.roles.my_app_admin"
          class="create-btn"
          color="#00457C"
          @click="createPromo"
          >Create Promotions</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <!-- Table -->
        <TableComponent
          type="popup"
          v-bind:dynamicHeaders="dynamicHeaders"
          v-bind:dynamicWidths="dynamicWidths"
          v-bind:dynamicRowsDetail="dynamicRowsDetail"
          v-on:view-item="viewPopup"
          v-on:edit-item="editPromo"
          v-on:delete-item="deletePopup"
          v-on:redeem-item="redeemPromo"
          v-on:view-item-analytics="viewAnalytics"
        />
      </v-col>
    </v-row>

    <!-- Dialog View -->
    <div
      v-if="currentAnalytics !== null"
      class="dialog-ann-wrapper dialog-screen-wrapper"
    >
      <div class="analytics-content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeDialog">Close</span>
        </div>
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>Total number of Redemptions</h4>
            </v-col>
            <v-col>
              {{ currentAnalytics.storeRedeemed.length }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>Total number of user claims</h4>
            </v-col>
            <v-col>
              {{ currentAnalytics.usersRedeemed.length }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>BBU Redemptions</h4>
            </v-col>
            <v-col> {{ bbuRedemption }} </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>Masai Redemptions</h4>
            </v-col>
            <v-col> {{ masaiRedemption }} </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>JJ Redemptions</h4>
            </v-col>
            <v-col> {{ jjRedemption }} </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>KL1 Redemptions</h4>
            </v-col>
            <v-col> {{ kl1Redemption }} </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col md="8">
              <h4>KL2 Redemptions</h4>
            </v-col>
            <v-col> {{ kl2Redemption }} </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import Axios from "axios";
import moment from "moment";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  created() {
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/promotions")
      .then((res) => {
        console.log("Successfully retrieved all details");
        this.rawPromoDetails = res.data;
        this.dynamicRowsDetail = this.processFetchedData(res.data);
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      dynamicHeaders: [
        { text: "Code", value: "name" },
        { text: "Description", value: "code", width: 200 },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["100px", "60px", "90px", "90px"],
      dynamicRowsDetail: [],
      dialog: false,
      selectedId: "",
      rawPromoDetails: [],
      promoPreviewDetails: {
        name: "",
        code: "",
        percentDiscount: "",
        dateTimeEnd: "",
        isEnabled: null,
      },
      promoPreview: false,
      loading: false,
      error: false,
      redeemId: null,
      userId: "",
      currentAnalytics: null,
    };
  },
  computed: {
    bbuRedemption() {
      var data = [];
      if (this.currentAnalytics !== null) {
        if (
          this.currentAnalytics.storeRedeemed !== undefined ||
          this.currentAnalytics.storeRedeemed.length !== 0
        ) {
          this.currentAnalytics.storeRedeemed.map((itm) => {
            if (itm.store == "mcm-s2bbu") {
              data.push(itm);
            }
          });
        }

        return data.length;
      }
      return 0;
    },
    jjRedemption() {
      var data = [];
      if (this.currentAnalytics !== null) {
        if (
          this.currentAnalytics.storeRedeemed !== undefined ||
          this.currentAnalytics.storeRedeemed.length !== 0
        ) {
          this.currentAnalytics.storeRedeemed.map((itm) => {
            if (itm.store == "mcm-s1jj") {
              data.push(itm);
            }
          });
        }

        return data.length;
      }
      return 0;
    },
    masaiRedemption() {
      var data = [];
      if (this.currentAnalytics !== null) {
        if (
          this.currentAnalytics.storeRedeemed !== undefined ||
          this.currentAnalytics.storeRedeemed.length !== 0
        ) {
          this.currentAnalytics.storeRedeemed.map((itm) => {
            if (itm.store == "mcm-s3ms") {
              data.push(itm);
            }
          });
        }

        return data.length;
      }
      return 0;
    },
    kl1Redemption() {
      var data = [];
      if (this.currentAnalytics !== null) {
        if (
          this.currentAnalytics.storeRedeemed !== undefined ||
          this.currentAnalytics.storeRedeemed.length !== 0
        ) {
          this.currentAnalytics.storeRedeemed.map((itm) => {
            if (itm.store == "mcm-k1sm") {
              data.push(itm);
            }
          });
        }

        return data.length;
      }
      return 0;
    },
    kl2Redemption() {
      var data = [];
      if (this.currentAnalytics !== null) {
        if (
          this.currentAnalytics.storeRedeemed !== undefined ||
          this.currentAnalytics.storeRedeemed.length !== 0
        ) {
          this.currentAnalytics.storeRedeemed.map((itm) => {
            if (itm.store == "mcm-k2sw") {
              data.push(itm);
            }
          });
        }

        return data.length;
      }
      return 0;
    },
  },
  methods: {
    processFetchedData(rawData) {
      return rawData.map(({ _id, name, code, dateTimeStart, dateTimeEnd }) => {
        const startDateDisplay = moment(dateTimeStart._seconds * 1000).format(
          "DD MMM YYYY"
        );
        const endDateDisplay = moment(dateTimeEnd._seconds * 1000).format(
          "DD MMM YYYY"
        );

        return {
          rowId: _id,
          name: name,
          code: code,
          startDate: startDateDisplay,
          endDate: endDateDisplay,
          action: {
            view: this.$store.state.user.roles.my_app_admin ? "show" : "hide",
            edit: this.$store.state.user.roles.my_app_admin ? "show" : "hide",
            delete: this.$store.state.user.roles.my_app_admin ? "show" : "hide",
            redeem: "show",
            analytics: this.$store.state.user.roles.my_app_admin
              ? "show"
              : "hide",
          },
        };
      });
    },
    viewPopup(id) {
      this.promoPreview = true;
      this.promoPreviewDetails = this.rawPromoDetails.find(
        (item) => item._id === id
      );
    },
    editPromo(id) {
      this.$router
        .push({
          name: "EditHomepagePromotions",
          params: { itemId: id },
        })
        .catch(() => {});
    },
    closeDialog() {
      this.redeemId = null;
      this.currentAnalytics = null;
    },
    redeemPromo(id) {
      this.redeemId = id;
      this.promoPreviewDetails = this.rawPromoDetails.find(
        (item) => item._id === id
      );
    },
    redeemPromotion() {
      if (this.userId !== "") {
        Axios.post(
          process.env.VUE_APP_HOST_SERVER +
            "/api/promotions/redeem-promo-code-from-store",
          {
            promoId: this.redeemId,
            docId: this.userId,
            store: this.$store.state.user.store,
          }
        )
          .then((res) => {
            this.$toast.open({
              message: res.data.message,
              type: res.data.status ? "success" : "warning",
              duration: 3000,
              position: "top-right",
              // all of other options may go here
            });
            this.userId = "";
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    deletePopup(id) {
      this.dialog = true;
      this.selectedId = id;
    },

    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete

      this.dialog = false;

      let id = this.selectedId;

      Axios.post(process.env.VUE_APP_HOST_SERVER + "/api/promotions/delete", {
        id: id,
      })
        .then(() => {
          this.loading = false; //disable loading screen once request is handled;
          this.error = false;
          //TODO: refine CODE to update promo table
          let deleteIndex = this.dynamicRowsDetail.findIndex(
            (item) => item.rowId === id
          );

          this.dynamicRowsDetail.splice(deleteIndex, 1);

          this.selectedId = "";
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
    createPromo() {
      this.$router.push({ name: "AddHomepagePromotions" }).catch(() => {});
    },

    getDaysLeft() {
      let currentDate = new Date();
      let endDate = this.promoPreviewDetails.dateTimeEnd;
      let difference = Date.parse(endDate) - Date.parse(currentDate);
      return Math.ceil(difference / (60 * 60 * 24 * 1000));
    },
    viewAnalytics(id) {
      this.currentAnalytics = this.rawPromoDetails.find(
        (item) => item._id == id
      );
    },
  },
};
</script>

<style scoped>
.analytics-content {
  width: 350px;
  height: 500px;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.redeem-content {
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.promo {
  width: 100%;
  height: 140px;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 3fr 5fr 4fr;
}

.discount {
  background-size: contain;
  width: 150px;
}

.discount > div:nth-child(2) {
  width: 30px;
  font-size: 16px;
  line-height: 1;
}

.promo-text {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 0 13px;
  color: black;
}

.promo-text > div:first-child {
  font-size: 16px;
}

.promo-text > div:nth-child(2) {
  font-size: 12px;
}

.cta {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding-right: 10px;
}

.cta > div {
  font-size: 12px;
  color: #9b9b9b;
  margin-bottom: 10px;
  text-align: center;
}

.cta > button {
  font-size: 12px;
  border: none;
  padding: 8px 30px;
  background: #2f80ed;
  border-radius: 25px;
  color: white;
}

input[type="text"],
input[type="number"],
input[type="date"] {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.redeem-btn {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}
</style>
